
<div class="w-full flex flex-col justify-start items-center">
  <SelectedFiltersLocationBar :products="products" />
  <div
    class="flex flex-col lg:flex-row flex-wrap gap-2"
  >
    <Card v-for="product in filteredProducts" :key="product.id" :product="product" />
  </div>
</div>
